import { isString } from 'radash';
import { backgroundColorAliases } from './aliases/background-colors.js';
import { colorAliases } from './aliases/colors.js';
import { fillColorAliases } from './aliases/fill-colors.js';
import { overlayColorAliases } from './aliases/overlay-colors.js';
import { strokeColorAliases } from './aliases/stroke-colors.js';
import { textColorAliases } from './aliases/text-colors.js';
import { textShadowAliases } from './aliases/text-shadows.js';
import { tintColorAliases } from './aliases/tint-colors.js';
import { typographyAliases } from './aliases/typography.js';
import * as index$1 from './maps/index.js';
import * as index from './tokens/index.js';
import { fillToOutlineColorTone } from './maps/fill-to-outline-color-tone.js';

/**
 * Creates and returns the theme object by merging design tokens with adjustable aliases based on
 * the theme's configuration. Also integrates token maps for thematic harmony.
 *
 * @param config - Configuration to tailor the theme.
 */ function createTheme(config = {}) {
    const { colorAliases: customColorAliases, colorInverted = false, colorMode = 'light' } = config;
    const mode = colorInverted ? 'dark' : colorMode;
    return {
        ...index,
        aliases: {
            backgroundColors: backgroundColorAliases[mode],
            colors: {
                ...colorAliases,
                ...customColorAliases
            },
            fillColors: fillColorAliases[mode],
            overlayColors: overlayColorAliases[mode],
            strokeColors: strokeColorAliases[mode],
            textColors: textColorAliases[mode],
            textShadows: textShadowAliases,
            tintColors: tintColorAliases,
            typography: typographyAliases
        },
        maps: {
            ...index$1,
            fillToOutlineColorTone: fillToOutlineColorTone[mode]
        }
    };
}
/**
 * Checks if a provided value matches a token from a set. If the match
 * is successful, it confirms the value's legitimacy as a token.
 *
 * @param token - The token to validate.
 * @param tokens - A set of tokens to check against.
 */ function isThemeToken(token, tokens) {
    return isString(token) && token in tokens;
}

export { createTheme, isThemeToken };
//# sourceMappingURL=theme.js.map
